/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".nav-pills[_ngcontent-%COMP%] > li.has-error[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{background-color:#f2dede;border-color:#ebccd1;color:#a94442}.nav-pills[_ngcontent-%COMP%] > li.is-ok[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{background-color:#dff0d8;border-color:#d6e9c6;color:#3c763d}.tab-container[_ngcontent-%COMP%]{max-height:300px;overflow-y:auto}"];
export { styles as styles };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/shared/components/vertical-tab-group/vertical-tab-group.component.css.shim.ngstyle.js.pre-build-optimizer.js